async function main() {

    const myLatLng = { lat: 44.8451905, lng: -73.4279178 };
    mapElement = document.getElementById('map')
    if(mapElement){
        let map;
        map = new google.maps.Map(mapElement, {
            center: myLatLng,
            zoom: 14,
            mapId: '8ef34546c097bd36',
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            disableDefaultUI: true,
        })
        const marker = new google.maps.Marker({
            position: myLatLng,
            icon: '/wp-content/themes/custom-theme/assets/img/giroux-map-marker.svg',
            map,
        });
    }
}

document.addEventListener('DOMContentLoaded', function(e) {
    let loaded = false;

    let callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !loaded) {
                loaded = true;
                main();
            }
        });
    };

    let observer = new IntersectionObserver(callback);

    let target = document.querySelector('.full-contact-form');
    observer.observe(target);
})